/**
 * Framer page-load appear (header jq1x2y): y -150 → 0, opacity ~0 → 1,
 * spring ~1s, delay 0.1s — same at all breakpoints.
 */
(function () {
  const header = document.querySelector('#header-component');
  const bar = header?.querySelector('.header__row--top');
  if (!header || !bar) return;

  const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function finish() {
    header.classList.add('wbs-header-appear-done');
    bar.classList.remove('wbs-header-appear-animate');
  }

  if (prefersReducedMotion()) {
    finish();
    return;
  }

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      bar.classList.add('wbs-header-appear-animate');

      let finished = false;
      const onDone = (event) => {
        if (finished || event.propertyName !== 'transform') return;
        finished = true;
        bar.removeEventListener('transitionend', onDone);
        finish();
      };

      bar.addEventListener('transitionend', onDone);
      window.setTimeout(() => {
        if (!finished) {
          bar.removeEventListener('transitionend', onDone);
          finish();
        }
      }, 1400);
    });
  });
})();
